var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 58,
    viewBox: "0 0 70 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0089 16.2146C19.1186 16.2146 21.0428 14.2899 21.0428 11.5257C21.0428 8.76147 19.1186 6.83674 16.0089 6.83674H7.81551V16.2146H16.0089ZM0.214844 0.0256987H16.1076C23.2641 0.0256987 28.6444 4.36866 28.6444 11.5257C28.6444 18.6822 23.2641 23.0256 16.1076 23.0256H7.81551V36.3027H0.214844V0.0256987Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1886 36.3962C60.2982 36.3962 62.223 34.4715 62.223 31.7073C62.223 28.9441 60.2982 27.0184 57.1886 27.0184H48.9952V36.3962H57.1886ZM41.3945 20.2073H57.2873C64.4438 20.2073 69.8241 24.5508 69.8241 31.7073C69.8241 38.8638 64.4438 43.2073 57.2873 43.2073H48.9952V56.4844H41.3945V20.2073Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2183 1.00864C42.6588 0.562012 43.5378 0.371017 45.4378 0.730793C48.3022 1.27317 51.7588 5.54111 55.4415 10.4028L43.4825 14.9421L45.9417 11.8502C47.6686 9.67926 48.015 6.69051 46.7526 4.22095C46.7092 4.13607 46.6707 4.06352 46.6376 4.00578C45.581 2.15114 44.4222 1.28057 43.3251 1.44837C41.0919 1.79037 39.9998 6.17183 39.5349 8.04424C39.1904 9.43201 38.5192 13.3964 38.5192 13.3964C37.9913 15.9304 36.9937 19.9765 35.9825 24.0781C34.895 28.4888 33.7917 32.9638 33.2396 35.6916C31.5794 43.8944 28.1223 58.011 17.2442 57.1231C16.1313 57.0323 15.1151 56.5733 14.1602 56.0389L17.3912 47.6234L17.5955 47.7611L20.0922 55.3539C20.2393 55.8005 20.7531 56.0769 21.1696 55.8587C22.1127 55.3642 23.0218 53.4938 23.2883 52.8808C23.6063 52.1521 23.8387 51.3898 24.0708 50.6286C24.1776 50.2784 24.2843 49.9285 24.3992 49.5822C25.8224 43.5333 27.7929 34.9737 29.5803 26.9766H21.1211L31.143 19.9068C31.661 17.5327 32.1369 15.3141 32.5462 13.354L32.8403 12.2766C33.9093 7.69137 36.3798 2.50845 41.2183 1.00864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7e5d69ad81877f3862dd8d3c5b5c2f1f.svg";
export { ForwardRef as ReactComponent };